import { computed, nextTick, onMounted, Ref, ref } from "vue";
import { VExpansionPanels } from "vuetify/lib/components";

export const usePanels = (
  initiallyOpened: string[] = [],
  panelRef: Ref<InstanceType<typeof VExpansionPanels> | null>
) => {
  const panels = ref<number[]>([]);
  const allPanelsByLabel = ref<string[]>([]);
  const allPanelsExpanded = computed(
    () => panels.value.length === totalNumberOfPanels.value
  );
  const totalNumberOfPanels = computed(() => allPanelsByLabel.value.length);

  const togglePanels = () => {
    panels.value = allPanelsExpanded.value
      ? []
      : [...Array(totalNumberOfPanels.value).keys()].map((_, i) => i);
    // allPanelsExpanded.value = !allPanelsExpanded.value;
  };

  /**
   * Collects the labels of all the panels in the component that this is used.
   * It does this by using the passed param "container" which is a reference to the
   * container vuetify component, from there we can query the "children" of that component
   * to receive all the children components and their names specifically.
   * @param container
   */
  const _collectPanels = (container: InstanceType<typeof VExpansionPanels>) => {
    return container.$children.map((child) => child?.$props.label);
  };

  /**
   * This watches the panelRef and on mount it will collect all the panels and then use the initiallyOpened
   * composable param to determine which panels should be opened on mount.
   */
  onMounted(() => {
    nextTick(() => {
      const interval = setInterval(() => {
        if (panelRef.value && allPanelsByLabel.value.length === 0) {
          allPanelsByLabel.value = _collectPanels(panelRef.value);
          panels.value = allPanelsByLabel.value
            .map((name, index) => (initiallyOpened.includes(name) ? index : -1))
            .filter((i) => i >= 0);
          if (allPanelsByLabel.value.length === 1) panels.value = [0];
          clearInterval(interval);
        }
      }, 100);
    });
  });

  return {
    allPanelsByLabel,
    allPanelsExpanded,
    panels,
    totalNumberOfPanels,
    togglePanels,
  };
};
